/*
*
* File JS componente Header
*
*/

// IMPORT MODULES
//--------------------------------------------------------------------//
import Headroom from "headroom.js";
import gsap from 'gsap';
import { stagger } from 'gsap/all';
 
// IMPORT SCSS PER LA COMPILAZIONE
//--------------------------------------------------------------------//

import './header.scss';

//--------------------------------------------------------------------//


/**
*	Script per il componente Header
*
*
*	@since  0.0.2
*	@author Guccy - IM*MEDIA
*
*	@return {void}
*/
const header = () =>
{

    /* Individuiamo dal DOM tutti gli elementi dell'header
    --------------------------------------------------------------------------*/
    const context = document.querySelector('#header');
    if( context === null ) return false;

    const navExpand = 1024;

    // /* Menu e megamenu
    // --------------------------------------------------------------------------*/
    const burgermenu = context.querySelector('.header__burger-trigger');

    /*/ Al click sul Burgermenu
    --------------------------------------------------------------------------*/
    if( burgermenu )
    {
        burgermenu.addEventListener('click', e=>
        {
            context.classList.toggle('mainmenu-opened');
            body.classList.toggle('mainmenu-opened');

            //ANIMAZIONE GSPAN DELEL VOCI DI MENU:
        
            if (context.classList.contains('mainmenu-opened')) {
                const menuItems = context.querySelectorAll('#menu-main-menu > li');
                gsap.fromTo(menuItems, 
                    { opacity: 0, x: -100 }, 
                    { duration: 0.5, opacity: 1, x: 0, stagger: 0.2, delay: 0.8 }
                );
            }
        });
    }

    // /* Menu DropDown
    // --------------------------------------------------------------------------*/
    const subMenus  = context.querySelectorAll('.header__menu ul > li.dropdown');
    const iconDropdown = '<div class="submenu-indicator"><svg width="20" height="14" viewBox="0 0 20 14" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0 6.50123H18.9362V7.5233L0 7.52321V6.50123Z" fill="currentColor"/><path d="M13.3777 0.5L20 7.05156L13.3777 13.5769L12.6329 12.8431L18.5106 7.05152L12.6329 1.23373L13.3777 0.5Z" fill="currentColor"/></svg></div>';


    /*/ Funzione di apertura del submenu
    // --------------------------------------------------------------------------*/
    function openSubMenu(el)
    {
        el.classList.add('open');
        context.classList.add('submenu-opened');

        let paddingSubMenu = 40;
        let heightSubmenu = 0;
        let elementsInSub = el.querySelectorAll(':scope > .dropdown-menu > li');

        if (elementsInSub) {

            //Nel caso di NavCompressed
            if (window.innerWidth < navExpand)
            {
                gsap.fromTo(elementsInSub, 
                    { opacity: 0, x: -50 }, 
                    { duration: 0.5, opacity: 1, x: 0, stagger: 0.2, delay: 0.2 }
                );
            }
            //Altrimenti:
            else
            {
                gsap.fromTo(elementsInSub, 
                    { opacity: 0, x: -50 }, 
                    { duration: 0.5, opacity: 1, x: 0, stagger: 0.2, delay: 1 }
                );
            }
        }

        //Calcolo per dare l'altezza al subMenu
        elementsInSub.forEach(element => 
        {
            heightSubmenu = heightSubmenu + element.offsetHeight;
        });

        el.querySelector(':scope > .dropdown-menu').style.height = (heightSubmenu + paddingSubMenu) + 'px';
       
    }

    /*/ Funzione di chiusa del submenu
    // --------------------------------------------------------------------------*/
    
    function closeSubMenu(el)
    {
        el.classList.remove('open');
        context.classList.remove('submenu-opened');

        //Nel caso di NavCompressed
        if (window.innerWidth < navExpand)
        {
            el.querySelector(':scope > .dropdown-menu').style.height = '';
        }
    }

    /*/ Aggiunta di EvetListner + Icona a tutti i subMenus
    // --------------------------------------------------------------------------*/

    subMenus.forEach((item, i) => {
        // Add icon dropdown
        item.firstElementChild.innerHTML += iconDropdown;

        item.addEventListener('click', () => {

            // Chiudi tutti i submenu tranne quello attuale
            subMenus.forEach((submenu, index) => {
                if (index !== i && submenu.classList.contains('open')) {
                    closeSubMenu(submenu);
                }
            });

            // Toggle del sottomenu attuale
            item.classList.contains('open') ? closeSubMenu(item) : openSubMenu(item);
        });
    
    });

    /*/ chiudi tutti i submenu aperti Se si il clicca al di fuori
    // --------------------------------------------------------------------------*/
    function closeSubMenuByClickOut()
    {
        
        const subMenusArray = Array.from(subMenus);

        document.addEventListener('click', (event) => {
            const clickedElement = event.target;
    
            const isLinkWithSubMenu = subMenusArray.some(submenu => submenu.contains(clickedElement));
    
            if (!isLinkWithSubMenu) {
                for (let i = 0; i < subMenusArray.length; i++) {
                    closeSubMenu(subMenusArray[i]);
                }
            }
        });
    }

    //Usa la funzione solo su navexpanded
    if (window.innerWidth > navExpand)
    {
        closeSubMenuByClickOut();
    }

    // --------------------------------------------------------------------------*/
    
   
    /*/ Funzione di Headroom
    // --------------------------------------------------------------------------*/
    const headroom = new Headroom(context);
    headroom.init();
    

   /*/ Funzione per la gestione dell'animazione allo scroll della navbar
    --------------------------------------------------------------------------*/
    function scrollDetectNav() 
    {
        let scrollUp = 'scroll-up';
        let scrollDown = 'scroll-down';
        let scrollDetect = 'scroll-detect';
        let lastScroll = 0;

        let navbarHeight = context.querySelector('.header__wrapper').offsetHeight;  


        window.addEventListener('resize', () => {
            navbarHeight = context.querySelector('.header__wrapper').offsetHeight;
        });

        window.addEventListener('scroll', () => {
            const currentScroll = window.scrollY;

            // if (body.classList.contains('open-submenu') || body.classList.contains('modal-open') || body.classList.contains('search-modal-open')) return;
            
            if (currentScroll == 0) 
            {
                body.classList.remove(scrollUp, scrollDetect);
                return;
            }
            
            if (currentScroll > lastScroll && !body.classList.contains(scrollDown) && currentScroll >= (navbarHeight + 800)) 
            {
                // Scroll Down
                body.classList.add(scrollDetect);
                
                if (currentScroll >= navbarHeight)
                {
                    body.classList.remove(scrollUp);
                    body.classList.add(scrollDown);
                }
            } 
            else if (currentScroll < lastScroll && body.classList.contains(scrollDown)) 
            {
                // Scroll Up
                body.classList.remove(scrollDown);
                body.classList.add(scrollUp);
            }
            lastScroll = currentScroll;
        });
    }

    scrollDetectNav();

    // --------------------------------------------------------------------------*/

}


// EXPORT COMPONENTE
//--------------------------------------------------------------------//

export default header;

//--------------------------------------------------------------------//